<template>
  <v-layout justify-center align-center fill-height pl-2 pt-4 pr-2 pb-2 row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-title dense primary-title class="headline primary">
              <v-layout row align-center>
                <v-btn dark icon @click="$router.push('/settings/promotions/')">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <span class="title font-weight-light white--text">Edit Promotion: <b>{{promotion.name}}</b></span>
              </v-layout>
            </v-card-title>
          </v-flex>
          <v-card-text>
            <v-flex xs12 md12>
              <PromotionForm
                v-if="!loading"
                ref="promotionForm"
                :disabled="disabled"
                :promotion="promotion" 
                :errors="errors"
                @validityChange="updateFormValidity($event)"
              />
              <v-divider class="mx-1"></v-divider>
            </v-flex>
            <v-flex xs12 md12 pt-1>
              <v-layout align-center justify-end row>
                <v-btn color="success" @click="update" class="text-none" :disabled="disabled">
                  Update
                </v-btn>
                </v-layout>
            </v-flex>
          </v-card-text>
        </v-layout>
      </v-card>
    </v-flex>
    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColour"
      :timeout="4000"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import PromotionForm from "@/components/settings/promotions/PromotionForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_customer",
  components: {
    PromotionForm
  },
  data: function() {
    return {
      promotion: null,
      errors: {},
      promotionFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      loading: true,
      disabled: false
    };
  },
  mounted: function() {
    this.getPromotionInfo();
  },
  methods: {
    getPromotionInfo: async function() {
      this.disabled = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/settings/promotions/${this.$route.params.id}/get`;

      axios.get(url).then(function(response) {
        if(!response.error) {
          if(response.data.promotion) {
            self.disabled = false;
            self.promotion = response.data.promotion;

            //Convert to pounds
            self.promotion.discount_fixed = self.promotion.discount_fixed / 100;
            self.promotion.max_booking_cost_with_discount = self.promotion.max_booking_cost_with_discount / 100;

            //Stop current codes from being deletable
            let fixedCodes = [];
            self.promotion.codes.forEach(function(code) {
              fixedCodes.push({
                code: code,
                new: false
              })
            })

            self.promotion.codes = fixedCodes;
          } else {
            self.promotion = {};
            self.snackbarMessage = "Error fetching promotion, no data"
            self.snackbarColour = "error";
            self.snackbarShow = true;
          }
        } else {
          console.log(response.error)
          self.promotion = {};
          self.snackbarMessage = "Error fetching promotion: " + response.error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
        }
        self.loading = false;
      }).catch(function(error) {
        console.log(error)
        self.promotion = {};
        self.snackbarMessage = error;
        self.snackbarColour = "error";
        self.snackbarShow = true;
        self.loading = false;
      });
    },
    update: async function() {
      if (this.promotionFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/promotions/${this.$route.params.id}/update`;

        //Format promo to send
        //Copy not reference
        let promotionToSend = Object.assign({}, this.promotion);
        let codesToSend = [];
        promotionToSend.codes.forEach(function(promocode) {
          codesToSend.push(promocode.code)
        });
        promotionToSend.codes = codesToSend;

        let data = { promotion: promotionToSend };
        axios({
          url: url,
          method: "post",
          data: encodeURIComponent(JSON.stringify(data)),
          headers: {
            'Content-Type': 'text/plain'
          }
        }).then(function(response) {
          console.log(response.data.errors)
          if(response.data.errors) {
            self.errors = response.data.errors;
            self.snackbarMessage = "Error updating promotion, please check the form"
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else if(response.data.error != "no_error") {
            self.snackbarMessage = "Error updating promotion: " + response.data.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
            console.log(response.data.error)
          } else {
            const promotionID = response.data.promotion.id;
            self.$router.push('../../promotions/');
          }
        }).catch(function(error) {
          console.log(error);
          self.snackbarMessage = "Network error: " + error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.promotionForm.validateForm();
      }
    },
    updateFormValidity: function(value) {
      this.promotionFormValid = value;
    }
  }
}
</script>